import { useTranslation } from "react-i18next";
import "../TermsPages/terms.css";
import NewLayout from "../layout/newLayout";

const SuperInstruction = () => {
  const { t } = useTranslation();
  return (
    <NewLayout>
      <div className="terms-pages">
        <div className="container">
          <h2>{t("Explanation for pharmacists at the Super Pharm")}</h2>
          <div className="terms-grid">
            <h3>{t("Ministry of Health")}</h3>
            <ol>
              <li>{t("Prescription Reception")}</li>
              <li>{t("Type patient details")}</li>
              <li>{t("Click Confirm To Show Medicines")}</li>
            </ol>
            <p>{t("Print Automatically")}</p>
          </div>
        </div>
      </div>
    </NewLayout>
  );
};

export default SuperInstruction;
